<footer>
    <!-- Footer Start-->
    <div class="footer-main">
            <div class="footer-area footer-padding">
                <div class="container">
                    <div class="row  justify-content-between">
                        <div class="col-lg-4 col-md-4 col-sm-8">
                            <div class="single-footer-caption mb-30">
                                <!-- logo -->
                                <div class="footer-logo">
                                    <a href="index.html"><img [src]="data.Logo1Url" alt=""></a>
                                </div>
                                <div class="footer-tittle">
                                    <div class="footer-pera">
                                        <p class="info1">{{data.Descricao}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-4 col-sm-5">
                            <div class="single-footer-caption mb-50">
                                <div class="footer-tittle">
                                    <h4>Links Rápidos</h4>
                                    <ul>
                                        <li *ngFor="let lk of data.Links"><a href="{{lk.Url}}">{{lk.Nome}}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-7">
                            <div class="single-footer-caption mb-50">
                                <div class="footer-tittle">
                                    <h4>Contato</h4>
                                    <div class="footer-pera">
                                        <p class="info1">{{data.Contato.Cidade}}/{{data.Contato.UF}} - {{data.Contato.Pais}}</p>
                                        <p class="info1">{{data.Contato.Endereco}}, {{data.Contato.Numero}} </p>
                                    </div>
                                    <ul>
                                        <li><a href="#">Fone: {{data.Fone}} </a></li>
                                        <!-- <li><a href="#">Cell: +95 (0) 123 456 789</a></li> -->
                                    </ul>
                                </div>
                            </div>

                            <div>
                                <iframe name="f2fe279e52dd324" width="1000px" height="1000px" data-testid="fb:page Facebook Social Plugin" title="fb:page Facebook Social Plugin" frameborder="0" allowtransparency="true" allowfullscreen="true" scrolling="no" allow="encrypted-media" src="https://web.facebook.com/v2.8/plugins/page.php?adapt_container_width=true&amp;app_id=1651358518454274&amp;channel=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df26270b2dd90328%26domain%3Dwww.ipb.agr.br%26origin%3Dhttp%253A%252F%252Fwww.ipb.agr.br%252Ff4c0f19d423ff%26relation%3Dparent.parent&amp;container_width=270&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2FIPBagro1%2F&amp;locale=pt_BR&amp;sdk=joey&amp;show_facepile=true&amp;small_header=false" style="border: none; visibility: visible; width: 100%; height: 130px;" class=""></iframe>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-8">
                            <div class="single-footer-caption mb-50">
                                <!-- Form -->
                                <!-- <div class="footer-form">
                                    <div id="mc_embed_signup">
                                        <form target="_blank" action="#" method="get" class="subscribe_form relative mail_part" novalidate="true">
                                            <input type="email" name="EMAIL" id="newsletter-form-email" placeholder=" Email " class="placeholder hide-on-focus" onfocus="this.placeholder = ''" onblur="this.placeholder = ' Email '">
                                            <div class="form-icon">
                                                <button type="submit" name="submit" id="newsletter-submit" class="email_icon newsletter-submit button-contactForm">
                                                    CADASTRAR
                                                </button>
                                            </div>
                                            <div class="mt-10 info"></div>
                                        </form>
                                    </div>
                                </div> -->
                                <!-- Map -->
                                <div class="map-footer text-center">
                                    <img *ngFor="let img of data.ImagensRodape" [src]="img.Url" alt="" style="width: 60%; height: auto; margin-bottom: 25px;">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Copy-Right -->
                    <div class="row align-items-center">
                        <div class="col-xl-12 ">
                            <div class="footer-copy-right">
                                <p>
Copyright &copy;<script>document.write(new Date().getFullYear());</script> Todos os direitos reservados | IPB Agro </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <!-- Footer End-->
</footer>